// Libraries
import React, { useState, useEffect } from 'react';

// Data, Services and Contexts
import questionsData from '../data/questions/questions-v1.json';
import dma from '../services/dma';

const QuestionsContext = React.createContext();

const QuestionsProvider = ({ children }) => {
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
    setQuestions(questionsData);
  }, []);

  const handleAnswer = (sectionIndex, questionIndex, answer) => {
    const updatedQuestions = [...questions];
    if (answer !== undefined)
      updatedQuestions[sectionIndex].questions[questionIndex].answer = answer;
    else delete updatedQuestions[sectionIndex].questions[questionIndex].answer;
    setQuestions(updatedQuestions);
  };

  const handleClearAllAnswers = () => {
    let updatedQuestions = [...questions];

    updatedQuestions.forEach((category) => {
      category.questions.forEach((question) => {
        delete question.answer;
      });
    });

    setQuestions(updatedQuestions);
  };

  return (
    <QuestionsContext.Provider
      value={{
        questions,
        handleAnswer,
        handleClearAllAnswers,
        calculateStats: dma.calculateStats,
        calculateCategoryStats: dma.calculateCategoryStats
      }}>
      {children}
    </QuestionsContext.Provider>
  );
};

export default QuestionsContext;
export { QuestionsProvider };
